const initialState = {
    phoneNumber: '',
    code: '',
    disabledBtn: true,
    isLoading: false,
    btnClass: 'disable-btn', 
};
const login = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_LOGIN':
            return {...state, [action.name]: action.value};
       	case 'CHANGE_DISABLE_BTN_PAGE_LOGIN':
            return {...state, disabledBtn: action.disabledBtn};
       	case 'CHANGE_LOADER_PAGE_LOGIN':
            return {...state, isLoading: action.isLoading};
        case 'CHANGE_BTN_CLASS_PAGE_LOGIN':
            return {...state, btnClass: action.className};
        default:
            return state;
    }
};

export default login;
